export default __webpack_public_path__ + "static/media/pexels-photo-1311518.ab03cd5a.jpeg";